
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
import MenuUploadCreateAddonDialog from "../dialogs/menu-upload-create-addon-dialog.vue";
import MenuUploadEmptyAddonDialog from "../dialogs/menu-upload-empty-addon-dialog.vue";
import MenuUploadGridItemAddonGroup from "./menu-upload-grid-item-addon-group.vue";
import menuUploadGridItemAvatarName from "./menu-upload-grid-item-avatar-name.vue";
export default {
  components: {
    menuUploadGridItemAvatarName,
    MenuUploadCreateAddonDialog,
    CreateEditAddonDialog,
    MenuUploadGridItemAddonGroup,
    MenuUploadEmptyAddonDialog
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showMenuUploadCreateAddonDialog: false,
      showAddNewAddonDialog: false,
      showEmptyAddonDialog: false,
      editingAddonInfo: null,
      selectedIndex: null
    };
  },
  computed: {
    ...mapState("menu", ["addons"])
  },
  methods: {
    ...mapMutations("menu", ["DELETE_ADDON_GROUP"]),
    handleShowCreateAddonDialog(data) {
      this.showMenuUploadCreateAddonDialog = true;
      if (data && data.groupInfo) {
        this.editingAddonInfo = data.groupInfo;
        this.selectedIndex = data.index;
      }
    },
    handleCreateAddonGroupDialogClose() {
      this.showMenuUploadCreateAddonDialog = false;
      this.selectedIndex = null;

      this.editingAddonInfo = null;
    },
    handleShowCreateAddonGroupDialog(addon) {
      this.editingAddonInfo.selectedItems.push(addon.id);

      this.showMenuUploadCreateAddonDialog = true;
    },
    handleShowAddonEmptyDialog() {
      if (this.addons.length) {
        this.showMenuUploadCreateAddonDialog = true;
      } else {
        this.showEmptyAddonDialog = true;
      }
    },
    handleDeleteAddonGroup({ itemId, index }) {
      this.DELETE_ADDON_GROUP({ itemId, index });
    },
    handleCreateOpenAddonDialog(data) {
      this.showAddNewAddonDialog = true;
      this.showMenuUploadCreateAddonDialog = false;
      if (data && data.groupInfo) {
        this.editingAddonInfo = data.groupInfo;
        this.selectedIndex = data.index;
      }
    }
  }
};
